module.exports = __webpack_public_path__ + "static/media/Ø1_4.fd6e5d8c.png";